import { SearchAndReplace } from './search-and-replace'
export * from './search-and-replace'
export default SearchAndReplace